<template>
    <div class="subscription" v-if="plan">
        <div class="loading" v-if="loading">
            <img
                class="logo"
                :src="require('@/assets/upmood-logo.svg')"
            />
        </div>
        <div class="checkout-wrapper" v-if="!isSuccess && !isFailed">
            <span class="checkout">Checkout</span>

            <div class="plan-wrapper">
                <p class="title">{{ plan.name }} Plan</p>
                <p class="price">{{ price }}</p>
            </div>

            <span class="monthly">{{ monthlyBill }}</span>

            <div class="terms">
                <router-link to="/terms" target="_blank">Terms and condition apply</router-link>
            </div>

            <button class="checkout-btn" v-if="plan.price === null" @click="checkout()">Checkout</button>

            <div ref="paypal" class="checkout-btn"></div>
        </div>

        <div class="success-wrapper" v-if="isSuccess">
            <div class="left">
                <h1>Success!</h1>
                <h3>You have successfully subscribed to moodmix. <br> Play the music up to {{ end }}.</h3>

                <button @click="$router.push({ name: 'Dashboard' })">Go to dashboard</button>
            </div>

            <div class="right">
                <img :src="require('@/assets/bear.png')" alt="bear">
            </div>
        </div>

        <div class="failed-wrapper" v-if="isFailed">
            <div class="left">
                <h1>Payment Unsuccesfull</h1>
                <h3>Sorry, we weren’t able to complete <br> your purchase at this time due to congestion.</h3>
                <h3 class="in-case">In case of any difficulties <br> contact us at support@upmood.com</h3>

                <button @click="$router.push({ name: 'Dashboard' })">Go to dashboard</button>
            </div>

            <div class="right">
                <img :src="require('@/assets/failed.png')" alt="bear">
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex';

export default {
	props: ['id'],
    
	data() {
		return {
			end: '',
			plan: null,
			isSuccess: false,
			isFailed: false,
			orderId: null,
			paypalBtnStyle: {
				label: "checkout",
				size: "medium",
				shape: "rect",
				color: "blue"
			},
            
			credentials: {
				sandbox:
                "AYEl0H0s9wyfmk2OGDtNOM2iuCEvHdIqqmrXoCrrG1FBhenSHW78tl52PT0DaTXlfndEe-RbnOT23DQW",
				production:
                "AQamiRvIUXuQb67mI0mbrSVppYw8niqIODEDfWcE4J_GHagp_V2bcXBJTkMZ9nCk-sp1sTzi13n7BSkg"
			}
		}
	},
    
	computed: {
		...mapState({
			loading: state => state.loading
		}),

		paypalEnv() {
			return process.env.VUE_APP_SERVER === "prod" ? "production" : "sandbox"
		},
        
		price () {
			const i = this.plan
			return `${i.price} ${i.currency.toUpperCase()} ${i.billing_cycle.charAt(0).toUpperCase() + i.billing_cycle.slice(1)}`
		},
        
		monthlyBill () {
			const i = this.plan
			return `${i.price} ${i.currency.toUpperCase()} billed  ${i.billing_cycle} (only ${i.monthly_price} ${i.currency.toUpperCase()} / month)`
		}
	},
    
	async created () {
		this.plan = await store.dispatch('getPlan', {id: this.id})
		if (this.plan.price) {
			const clientID = process.env.NODE_ENV === 'production' && process.env.VUE_APP_SERVER === 'prod' ?
				'AQamiRvIUXuQb67mI0mbrSVppYw8niqIODEDfWcE4J_GHagp_V2bcXBJTkMZ9nCk-sp1sTzi13n7BSkg' :
				'AYEl0H0s9wyfmk2OGDtNOM2iuCEvHdIqqmrXoCrrG1FBhenSHW78tl52PT0DaTXlfndEe-RbnOT23DQW'
    
			const script = document.createElement('script')
			script.src = `https://www.paypal.com/sdk/js?client-id=${clientID}&disable-funding=credit,card`
			script.addEventListener('load', this.setLoaded)
			document.head.appendChild(script)
		}
	},
    
	methods: {
		setLoaded () {
			window.paypal.Buttons({
				style: {
					label: "paypal",
					shape: "rect",
					color: "blue"
			    },
				createOrder: (data, actions) => {
					return actions.order.create({
						purchase_units: [
							{
								amount: {
									currency_code: this.plan.currency.toUpperCase(),
									value: this.plan.price
								}
							}
						]
					})
				},
				onApprove: async (data, actions) => {
					const order = await actions.order.capture();
					this.$store.commit('SET_LOADING', true)
					this.onPaymentSuccess(order)
				},
				onError: err => {
					console.log(err);
					this.isFailed = true
				}

			})
				.render(this.$refs.paypal);
                
			console.log(window.paypal.Buttons)
		},

		onPaymentCancelled() {
			this.orderderId = null;
		},
        
		async checkout () {
			// for trial plan only
			const result = await this.$store.dispatch('subscribe', {
				plan_id: this.id
			})

			if (result.status) {
				this.end = result.end
				this.isSuccess = true
			} else this.isFailed = true
		},
        
		async onPaymentSuccess(data) {
			this.orderId = data.purchase_units[0].payments.captures[0].id
			const result = await this.$store.dispatch('subscribe', {
				transaction_id: this.orderId,
				plan_id: this.id
			})

			if (result.status) {
				this.end = result.end
				this.isSuccess = true
			} else this.isFailed = true
		},
	}
}
</script>

<style lang="scss" scoped>
.subscription {
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        height: 100%;
        width: 100%; 
        background-color: #000;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        z-index: 9999;;
        opacity: 0.8;

        .logo {
            height: 120px;
            width: 120px;
        }
    }
    .checkout-wrapper {
        padding-top: 60px;
        width: 465px;
        display: flex;
        flex-direction: column;
        margin: auto;
        color: #BAB1C9;

        @include mobile {
            width: 305px;
        }

        .checkout {
            font-size: 18px;
            margin-bottom: 28px;
        }

        .monthly {
            font-size: 18px;
            margin-bottom: 60px;
        }

        .terms {
            margin-bottom: 60px;

            a {
                color: #FFFFFF;
                font-size: 14px;
            }
        }

        .checkout-btn {
            width: 250px;
        }

        .plan-wrapper {
            width: 460px;
            height: 170px;
            background-color: #4C405F;
            border: 1px solid #707070;
            border-radius: 3px;
            opacity: 1;
            padding: 65px 0 0 21px;
            margin-bottom: 23px;

            @include mobile {
                width: 300px;
            }

            p {
                color: #BAB1C9;
                font-size: 18px;

                &.title {
                    margin-bottom: 15px;
                    text-transform: capitalize;
                }
            }
        }
    }
    
    .success-wrapper {
        padding-top: 60px;
        width: 1024px;
        display: flex;
        margin: auto;
        color: #BAB1C9;

        @include mobile {
            width: 380px;
        }

        @media screen and (max-width: 1024px) {
            width: 460px;
        }

        .left {
            width: 335px;
            margin-right: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            @include mobile {
                margin: auto;
            }

            h1 {
                font-family: Quicksand, sans-serif;
                color: #BAB1C9;
                font-size: 45px;
                margin-bottom: 51px;
            }

            h3 {
                color: #BAB1C9;
                font-size: 18px;
                margin-bottom: 75px;
                font-weight: 400;
            }

            button {
                background-color: #8158BE;
                width: 145px;
            }
        }

        .right {
            @media screen and (max-width: 1024px) {
                display: none;
            }
        }
    }

    .failed-wrapper {
        padding-top: 185px;
        width: 1024px;
        display: flex;
        margin: auto;
        color: #BAB1C9;

        @include mobile {
            width: 400px;
        }

        @media screen and (max-width: 1024px) {
            width: 485px;
            padding-top: 60px;

        }

        .left {
            width: 485px;
            margin-right: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            @include mobile {
                margin: auto;
                width: 335px;
            }

            @media screen and (max-width: 1024px) {
                margin: auto;
            }

            h1 {
                font-family: Quicksand, sans-serif;
                color: #BAB1C9;
                font-size: 45px;
                margin-bottom: 51px;
            }

            h3 {
                color: #BAB1C9;
                font-size: 18px;
                margin-bottom: 35px;
                font-weight: 400;

                &.in-case {
                    margin-bottom: 65px;
                }
            }

            button {
                background-color: #8158BE;
                width: 145px;
            }
        }

        .right {
            @media screen and (max-width: 1024px) {
                display: none;
            }
        }
    }
}
</style>